import { isAllOption } from '@/ui/utils/content';
import useConfigurableTokens from '../hooks/use-configurable-tokens.js';
import type { ChainNameSelection } from '../types.js';
import TokenList from './token-list.js';

export interface AvailableTokensProps {
  chains: string[];
  selectedChains: ChainNameSelection;
}

function ConfigurableTokens({ chains, selectedChains }: AvailableTokensProps) {
  const tokens = useConfigurableTokens(
    isAllOption(selectedChains) ? chains : selectedChains,
  );
  return <TokenList tokens={tokens} />;
}

export default ConfigurableTokens;
